<template>
    <div class="main-body">
        <h2>{{ $strings('cpsite/balance/title') }}</h2>
        <div>
            <h4>{{ $strings('cpsite/balance/balance') }}</h4>
            <el-row :gutter="16">
                <el-col :span="6">
                    <el-card shadow="never" v-loading="tableLoading">
                        <div>
                            <span v-if="balance > 0" class="font-32">{{ balance.toFixed(2) }}</span>
                            <span v-else>...</span>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div>
            <h4>{{ $strings('cpsite/balance/topup') }}</h4>
            <el-table
                v-loading="tableLoading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')" width="200">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" :label="$strings('word/topup_amount')">
                    <template slot-scope="scope">
                        {{ scope.row.amount.toFixed(2) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {CpSiteBalanceRead} from "@/api/cpsite/api";
import {UnixToDateFull} from "@/utils/time";
import {GetItem} from "@/utils/storage";
import {STORAGE_KEY_LOGIN_TZ} from "@/config/config";

export default {
    name: "cpsite-balance",
    data() {
        return {
            balance: 0,
            tableLoading: true,
            tableData: []
        }
    },
    created() {
        this.refreshTable();
    },
    methods: {
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        refreshTable() {
            CpSiteBalanceRead({}).then((resp) => {
                this.balance = resp.data.data.balance;
                this.tableData = resp.data.data.rows;
            }).finally(() => {
                this.tableLoading = false
            });
        }
    }
}
</script>

<style scoped>

</style>